<template>
  <div>
    <div class="text-nowrap" v-if="order.external_id">
      {{order.external_id | cleanentityprefix}}
      <a href="#" v-if="order.external_id" @click.prevent="copyToClipboard(order.external_id)" class="text-secondary" :title="$gettext('Copy to Clipboard')">
        <font-awesome-icon :icon="['far', 'copy']" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShippingOrdersListItemExternalId',
  props: {
    order: {
      type: Object,
      default: () => {},
      required: true
    }
  }
}
</script>
